.list {
    color: var(--hps-blue);
    padding-left: 32px;
}